module.exports = __webpack_public_path__ + "assets/img/20-double-eleven_task-one.dfb5096a.png";